import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { useLocation } from 'react-router-dom';

const footerLinkStyle = {
  fontSize: '1.1rem',
  color: '#0e456c',
  textDecoration: 'none',
  fontWeight: '500'
};

const complianceLinks = [
  { label: 'Safety & Compliance', href: 'https://fundraisingu.net/safety/' },
  { label: 'Privacy Policy', href: 'https://fundraisingu.net/safety/privacy-policy/' },
  { label: 'Text Messaging (TCPA)', href: 'https://fundraisingu.net/safety/text-messaging/' },
  { label: 'Accessibility', href: 'https://fundraisingu.net/safety/accessibility/' }
];

const LayoutContent = ({ children, location }) => {
  // Check if current page is an order page or help page
  const isOrderPage = location.pathname.includes('/Order/') || 
                     location.pathname.includes('/order/') ||
                     location.pathname.includes('/Order') ||
                     location.pathname.includes('/order');
  
  const isHelpPage = location.pathname === '/Help' ||
                    location.pathname === '/help';

  // Pages ported from the Laravel site bring their own Laravel page frame.
  if (/^\/(donations|receipt)\//i.test(location.pathname)) {
    return children;
  }

  return (
    <div className="main-div">
      <NavMenu />
      
      {/* Header with logo and message - shown on all pages except orders and help */}
      {!isOrderPage && !isHelpPage && (
        <header style={{
          backgroundColor: '#f8f9fa',
          padding: '1.5rem 0',
          borderBottom: '1px solid #dee2e6',
          marginBottom: '2rem'
        }}>
          <Container>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '1rem'
            }}>
              <img
                src="./media/logo/logo.png"
                alt="Fundraising University"
                style={{
                  height: '50px',
                  width: 'auto'
                }}
              />
              <span style={{
                fontSize: '1.1rem',
                color: '#6c757d',
                fontWeight: '500'
              }}>
                Fueled by Fundraising University
              </span>
            </div>
          </Container>
        </header>
      )}
      
      <Container>
        {children}
      </Container>
      
      {/* Footer with Fundraising University Logo and Text */}
      <footer style={{
          backgroundColor: '#f8f9fa',
          padding: '2rem',
          marginTop: '3rem',
          textAlign: 'center',
          borderTop: '2px solid #dee2e6'
      }}>
          <Container>
              {/* Logo and Text */}
              <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '1rem',
                  marginBottom: '1.5rem'
              }}>
                  <img
                      src="./media/logo/logo.png"
                      alt="Fundraising University"
                      style={{
                          height: '60px',
                          width: 'auto'
                      }}
                  />
                  <span style={{
                      fontSize: '1.2rem',
                      color: '#6c757d',
                      fontWeight: '500'
                  }}>
                      Fueled by Fundraising University
                  </span>
              </div>
              
              {/* Footer links */}
              <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  gap: '0.75rem 1.5rem'
              }}>
                  <a
                      href="/Help"
                      style={footerLinkStyle}
                  >
                      Help & Support
                  </a>
                  {complianceLinks.map(({ label, href }) => (
                      <a
                          key={href}
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={footerLinkStyle}
                      >
                          {label}
                      </a>
                  ))}
              </div>
          </Container>
      </footer>
    </div>
  );
};

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <LayoutWrapper>
        {this.props.children}
      </LayoutWrapper>
    );
  }
}

// Wrapper component to use hooks
const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  return <LayoutContent children={children} location={location} />;
};
